<template>
  <a-modal :width="!!form.trip_days && form.trip_days.length > 0 ? '876px' : '500px'"
    :title="form.trip_id ? '修改登记信息' : '新增登记信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-row>
      <a-col :span="!!form.trip_days && form.trip_days.length > 0 ? 12 : 24">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="登记姓名" prop="id_name">
            <a-input v-model="form.id_name" placeholder="请输入行程名称" />
          </a-form-model-item>
          <a-form-model-item label="证件类型" prop="id_type">
            <a-radio-group v-model="form.id_type">
              <a-radio value="2">
                港澳台通信证
              </a-radio>
              <a-radio value="1">
                第二代居民身份证
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="id_number">
            <a-input v-model="form.id_number" placeholder="请输入证件号码" />
          </a-form-model-item>
          <a-form-model-item label="证件正面照" prop="id_front">
            <a-row>
              <a-col :span="12">
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  @change="handleChange($event, 'id_front')" @preview="preview" :show-upload-list="false">
                  <img v-if="form.id_front" :src="form.id_front" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-col>
              <a-col :span="1" v-if="form.id_front"><a-button icon="close" type="danger" size="small"
                  @click="remove('id_front')"></a-button></a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="证件背面照" prop="id_back">
            <a-row>
              <a-col :span="12">
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  @change="handleChange($event, 'id_back')" @preview="preview" :show-upload-list="false">
                  <img v-if="form.id_back" :src="form.id_back" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-col>
              <a-col :span="1" v-if="form.id_back"><a-button icon="close" type="danger" size="small"
                  @click="remove('id_back')"></a-button></a-col>
            </a-row>
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col span="12" v-if="!!form.trip_days && form.trip_days.length > 0">
        <a-form-model-item label="行程配置">
          <div v-for="(v, i) in form.trip_msg" style="margin-bottom: 20px;">
            <a-input-group>
              <a-divider orientation="left">
                {{ v.date }} 当天行程规划
              </a-divider>
              <a-row :gutter="[8, 8]">
                <a-col :span="8">
                  <a-input v-model="v.date" disabled />
                </a-col>
                <a-col :span="13">
                  <a-input placeholder="行程地点" v-model="v.address" />
                </a-col>
                <a-col :span="2">
                  <a-button icon="delete" style="font-size: 18px;" type="danger" @click="del(i)"></a-button>
                </a-col>
                <a-col :span="24">
                  <a-input placeholder="行程配置（例如：车、酒店等）" v-model="v.p_n" />
                </a-col>
                <a-col :span="24">
                  <a-textarea placeholder="行程计划（例如上午或下午的详细计划）" v-model="v.p_l" />
                </a-col>
              </a-row>
            </a-input-group>
          </div>
        </a-form-model-item>

      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { baseURL } from "@/api/index";
export default {
  data() {
    return {
      baseURL,
      loading: false,
      visible: false,
      confirmLoading: false,
      times: [],
      form: {
        id_info_id: "",
        customer_id: '',
        id_type: '2',
        id_name: '',
        id_number: '',
        id_front: '',
        id_back: ''
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        id_name: [
          {
            required: true,
            message: "请输入登记姓名",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  computed: {
    timelength() {
      if (!!this.form.trip_days && this.form.trip_days.length > 0) {
        return this.form.trip_days.length
        // (new Date(this.times[1]) - new Date(this.times[0])) / 86400000 + 1

      } else {
        return 0;
      }
    },
  },
  methods: {
    init(id_info_id, customer_id) {
      this.visible = true;
      this.form.id_info_id = id_info_id;
      this.form.customer_id = customer_id;
      if (id_info_id) {
        this.$http({
          url: "/admin/idinfo/info",
          method: "post",
          data: {
            id: id_info_id,
          },
        }).then((res) => {
          // this.form = { ...res.data, trip_days: res.data.trip_days.split(','), trip_msg: res.data.trip_msg ? JSON.parse(res.data.trip_msg) : [] };
          // this.times = res.data.trip_days.split(',');
          this.form = { ...res.data }
        });
      }
    },
    del(index) {
      this.$confirm({
        title: '是否删除当前选择的行程',
        content: '删除后再做保存操作后，数据将不再恢复',
        onOk: () => {
          this.form.trip_msg.splice(index, 1)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    handleChange(info, _) {
      // let fileList = [...info.fileList];
      // fileList = fileList.slice(-1);
      // fileList = fileList.map((file) => {
      //   if (file.response) {
      //     file.url = file.response.data.url;
      //     this.form.department_logo = file.response.data.url;
      //   }
      //   return file;
      // });
      // this.fileList = fileList;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        this.loading = false;
        this.form[_] = info.file.response.data.url;
      }
    },
    preview(e) {
      this.$viewerApi({
        images: [e.response.url],
      });
    },
    remove(_) {
      this.form[_] = "";
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.id_info_id
              ? "/admin/idinfo/update"
              : "/admin/idinfo/create",
            method: "post",
            data: {
              ...this.form,
            },
          })
            .then(() => {
              this.$message.success(
                this.form.id_info_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeDays(e) {
      console.log(e)
      for (let i = 0; i < e.length; i++) {
        const index = this.form.trip_msg.findIndex(v => v.date == e[i])
        if (index == -1) {
          this.form.trip_msg.push({
            date: e[i],
            address: '',
            p_n: "",
            p_l: ""
          })
        }
      }

      this.form.trip_msg.sort((a, b) => new Date(a.date) - new Date(b.date))
    },
    handleCancel() {
      this.visible = false;
      this.times = [];
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    //切换行程时间
    timesChange(e) {
      console.log(e);
      if (e.length == 2) {
        this.form.trip_start = e[0];
        this.form.trip_end = e[1];
      } else {
        this.form.trip_start = "";
        this.form.trip_end = "";
      }
    },
  },
};
</script>

<style></style>